import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
import dayjs from 'src/libs/dayjs';
import { Pagination } from 'src/interfaces/general';

export type State = {
  loading: boolean;
  unread_count: number;
  pagination: Partial<Pagination>;
};

export const adapter = createEntityAdapter<Model.Notification>({
  selectId: (model) => model.id,
  sortComparer: (a, b) => {
    return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? 1 : -1;
  },
});

const { reducer, actions } = createSlice({
  name: 'notifications',
  initialState: adapter.getInitialState<State>({
    loading: false,
    unread_count: 0,
    pagination: {},
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.Notification[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.Notification>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateUnread(state, action: PayloadAction<number>) {
      state.unread_count = action.payload;
    },
    updatePagination(state, action: PayloadAction<Pagination>) {
      state.pagination = action.payload;
    },
    updateRead(state, action: PayloadAction<string>) {
      adapter.updateOne(state, {
        id: action.payload,
        changes: { is_read: true },
      });
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.user_notification,
);

export const selectNotificationsHistory = createSelector(
  selector.selectAll,
  (state: RootState) => state.ui.app.me?.id,
  (notifications, id) => {
    return notifications.filter((n) => n.user_id === id);
  },
);

export { reducer };
export default actions;
